/**
 * Mmd Animation Base class for runtime injection
 */
export class MmdAnimationBase {
    /**
     * Animation name for identification
     */
    name;
    /**
     * Bone animation tracks for one `mesh.skeleton`
     *
     * it contains rotation and rotation cubic interpolation data
     */
    boneTracks;
    /**
     * Movable bone animation tracks for one `mesh.skeleton`
     *
     * it contains position, rotation and their cubic interpolation data
     */
    movableBoneTracks;
    /**
     * Morph animation tracks for one `mesh.morphTargetManager`
     *
     * it contains weight and weight linear interpolation data
     */
    morphTracks;
    /**
     * Property animation track for one `mmdModel`
     *
     * it contains visibility and ik toggle keyframe data
     */
    propertyTrack;
    /**
     * Camera animation track for one `mmdCamera`
     *
     * it contains position, rotation, distance and fov cubic interpolation data
     */
    cameraTrack;
    /**
     * The start frame of this animation
     */
    startFrame;
    /**
     * The end frame of this animation
     */
    endFrame;
    /**
     * Create a new `MmdAnimationBase` instance
     * @param name animation name for identification
     * @param boneTracks bone animation tracks
     * @param movableBoneTracks movable bone animation tracks
     * @param morphTracks morph animation tracks
     * @param propertyTrack property animation track
     * @param cameraTrack camera animation track
     */
    constructor(name, boneTracks, movableBoneTracks, morphTracks, propertyTrack, cameraTrack) {
        this.name = name;
        this.boneTracks = boneTracks;
        this.movableBoneTracks = movableBoneTracks;
        this.morphTracks = morphTracks;
        this.propertyTrack = propertyTrack;
        this.cameraTrack = cameraTrack;
        let minStartFrame = Number.MAX_SAFE_INTEGER;
        let maxEndFrame = Number.MIN_SAFE_INTEGER;
        for (let i = 0; i < boneTracks.length; ++i) {
            const boneTrack = boneTracks[i];
            minStartFrame = Math.min(minStartFrame, boneTrack.startFrame);
            maxEndFrame = Math.max(maxEndFrame, boneTrack.endFrame);
        }
        for (let i = 0; i < movableBoneTracks.length; ++i) {
            const movableBoneTrack = movableBoneTracks[i];
            minStartFrame = Math.min(minStartFrame, movableBoneTrack.startFrame);
            maxEndFrame = Math.max(maxEndFrame, movableBoneTrack.endFrame);
        }
        for (let i = 0; i < morphTracks.length; ++i) {
            const morphTrack = morphTracks[i];
            minStartFrame = Math.min(minStartFrame, morphTrack.startFrame);
            maxEndFrame = Math.max(maxEndFrame, morphTrack.endFrame);
        }
        minStartFrame = Math.min(minStartFrame, propertyTrack.startFrame);
        maxEndFrame = Math.max(maxEndFrame, propertyTrack.endFrame);
        minStartFrame = Math.min(minStartFrame, cameraTrack.startFrame);
        maxEndFrame = Math.max(maxEndFrame, cameraTrack.endFrame);
        this.startFrame = minStartFrame;
        this.endFrame = maxEndFrame;
    }
}
